// extracted by mini-css-extract-plugin
export default {"modalContent":"UpdatePickUpPointModal_modalContent__kbI22"};